<template>
    <div class="report__dashboard_show_systemusage_box">
        <div class="report__dashboard_show_systemusage_box_top">
            <div class="report__dashboard_show_systemusage_box_top_number">
                <div class="report__dashboard_show_systemusage_box_top_number_content">
                    <template v-if="requestPending">
                        <component-loading :size="'small'"></component-loading>
                    </template>
                    <template v-else>
                        {{ dataOutput }}
                    </template>
                </div>
            </div>
            <div class="report__dashboard_show_systemusage_box_top_label">
                <div class="report__dashboard_show_systemusage_box_top_label_content">
                    {{ label }}
                </div>
            </div>
        </div>
        <template v-if="extraOptions">
            <div class="report__dashboard_show_systemusage_box_bottom">
                <div class="columns is-vcentered">
                    <div class="column is-narrow">
                        Over:
                    </div>
                    <div class="column">
                        <form-select
                            :label="''"
                            :disabled="requestPending"
                            :name="`report-dashboard-show-system-usage-box-select`"
                            :value="selectOption"
                            :items="[
                                {
                                    label: 'Last month',
                                    value: 'month'
                                },
                                {
                                    label: 'Last 12 months',
                                    value: 'year'
                                }
                            ]"
                            :is-type="'select'"
                            :prevent-clear="true"
                            @input="emitFilterSelect"
                        />
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <form-checkbox
                            :label="'Include weekends'"
                            :disabled="requestPending"
                            :name="`report-dashboard-show-system-usage-box-checkbox`"
                            :value="checkboxOption"
                            @input="emitFilterCheckbox"
                        >
                        </form-checkbox>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import FormSelect from '@/components/default/forms/FormSelect'
import FormCheckbox from '@/components/default/forms/FormCheckbox'

export default {
  name: 'report-dashboard-show-system-usage-box',
  components: { FormCheckbox, FormSelect, ComponentLoading },
  data () {
    return {
      requestPending: false
    }
  },
  props: {
    label: {
      type: String
    },
    dispatchName: {
      type: String
    },
    getterName: {
      type: String
    },
    extraOptions: {
      type: Boolean,
      default: false
    },
    selectOption: {
      type: String
    },
    checkboxOption: {
      type: Boolean
    }
  },
  computed: {
    dataOutput () {
      return this.$store.getters[this.getterName]
    },
    watchComputed () {
      return this.selectOption + this.checkboxOption
    }
  },
  watch: {
    watchComputed () {
      this.performGetData()
    }
  },
  methods: {
    performGetData () {
      this.requestPending = true
      this.$store.dispatch(this.dispatchName, { selectOption: this.selectOption, checkboxOption: this.checkboxOption }).finally(() => {
        this.requestPending = false
      })
    },
    emitFilterSelect (value) {
      this.$emit('emit-filter-select', value.value)
    },
    emitFilterCheckbox (value) {
      this.$emit('emit-filter-checkbox', value)
    }
  },
  created () {
    this.performGetData()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardsystemusagebox.scss";
</style>
